export enum ECompanySettingsTabs {
	UserAccounts = 'UserAccounts',
	BusinessId = 'BusinessId',
	Notifications = 'Notifications',
	Jobs = 'Jobs',
}
